import SockJS from 'sockjs-client';
import { EventPusherUrl } from './vendor/weblink/nguc-javascript-client/Enums';

const URL = (window.location.origin !== 'https://infinity.infracom.se') ? EventPusherUrl.production : EventPusherUrl.beta
//let URL = EventPusherUrl.beta;

let accessToken = "";
const messageCallbacks: {[key: string]: {[key: string]: (arg: any) => void}} = {};
const closeCallbacks: (() => void)[] = [];
const openCallbacks: (() => void)[] = [];
let unique = 1;

export default class Pusher {
	sockjs: any
	isOpen: boolean

	constructor(accessTokenn: string) {
		accessToken = accessTokenn;
		this.isOpen = false
	}

	open() {
		if(this.isOpen) {
			return;
		}

		this.sockjs = new SockJS(URL);

		this.sockjs.onopen = () => {
			console.log('SockJS open')

			this.sockjs.send(JSON.stringify([
				'authenticate',
				{ authorization: `Bearer ${accessToken}` }
			]))

			this.triggerOpen();
		}

		this.sockjs.onmessage = (e: any) => {
			const data = JSON.parse(e.data);

			this.triggerMessage(data[0], data[1])
		}

		this.sockjs.onclose = () => {
			console.log('SockJS closed');
			this.triggerClose();
		}

		this.isOpen = true;
	}

	close() {
		if(this.isOpen) {
			this.sockjs.close()
			this.isOpen = false
		}
	}

	pushOnMessageListener(event: string, callback: () => void): number {
		if(!Object.prototype.hasOwnProperty.call(messageCallbacks, event)) {
			messageCallbacks[event] = {}
		}

		const u = unique++

		messageCallbacks[event][u] = callback

		return u
	}

	removeOnPushMessageListener(event: string, i: number) {
		delete messageCallbacks[event][i]
	}

	pushOnCloseListener(callback: () => void) {
		closeCallbacks.push(callback)
	}

	pushOnOpenListener(callback: () => void) {
		openCallbacks.push(callback)
	}

	triggerMessage(event: string, data: any) {
		if(Object.prototype.hasOwnProperty.call(messageCallbacks, event)) {
			for(const i in messageCallbacks[event]) {
				messageCallbacks[event][i].apply(this, [data])
			}
		}
	}

	triggerClose() {
		for(const i in closeCallbacks) {
			closeCallbacks[i]()
		}
	}

	triggerOpen() {
		for(const i in openCallbacks) {
			openCallbacks[i]()
		}
	}
}
